import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddCrest = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 253 296",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M126.73,0L0,46.09v134.13l.31,2.52c.27,1.15,7.17,28.54,25.77,56.18,25.3,37.6,60.1,57.46,100.65,57.46s75.34-19.88,100.65-57.46c18.61-27.64,25.49-55.02,25.77-56.18l.31-136.65L126.73,0ZM232.35,178.86c-3.16,11.62-28.83,96.4-105.61,96.4S24.28,190.48,21.12,178.86V60.87L126.73,22.47l105.61,38.4v117.98h0Z" }), /* @__PURE__ */ _jsx("polygon", { points: "116.17 85.16 116.17 132.68 68.65 132.68 68.65 153.8 116.17 153.8 116.17 201.33 137.3 201.33 137.3 153.8 184.82 153.8 184.82 132.68 137.3 132.68 137.3 85.16 116.17 85.16" })] })
});
export default SvgAddCrest;
